module.exports = __webpack_public_path__ + "media/images/flags/64/Gibraltar-1ebbba265d14a67593f21122fb3e7635.png";